/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-12 15:53:15
 * @LastEditTime: 2025-03-21 11:35:58
 */
import request from '@/utils/request';

// 加入购物车
export const addCartShopping = (data:any) =>
  request({
    url: `orderCenter/cart/add.json`,
    method: 'post',
    data
  });

// 获取购物车详情列表
export const getCartList = () =>
  request({
    url: `orderCenter/cart/getCartInfo.json`,
  });

// 删除购物车商品
export const deleteCartGoods = (data: any) => 
  request({
    url: `orderCenter/cart/remove.json`,
    method: 'post',
    data
  });

  

// 清空失效商品
export const clearInvalidGoods = () => 
  request({
    url: `orderCenter/cart/removeExpired.json`,
    method: 'post',
  })
  
//结算
export const settleAccountsGoods = (data:any) =>
  request({
    url: `orderCenter/cart/saveTempDate.json`,
    method: 'post',
    data
  })
  // product/page/config.json?type=1
  //获取授权码设备台数
  export const getComputeNum = () =>
  request({
    url: `product/page/config.json?type=1`,
  });